export type MediaImage = {
  src: string;
  width: number;
  height: number;
  srcSetAvif: string;
  srcSetWebp: string;
};

function img(
  name: string,
  ext: "jpg" | "png",
  width: number,
  height: number,
  widths: number[],
): MediaImage {
  return {
    src: `/media/${name}.${ext}`,
    width,
    height,
    srcSetAvif: widths.map((w) => `/media/${name}-${w}.avif ${w}w`).join(", "),
    srcSetWebp: widths.map((w) => `/media/${name}-${w}.webp ${w}w`).join(", "),
  };
}

export const MEDIA = {
  photo1: img("photo1", "jpg", 1920, 1280, [800, 1400, 1920]),
  photo3: img("photo-3", "jpg", 800, 534, [400, 800]),
  photo4: img("photo-4", "jpg", 1200, 1789, [600, 1200]),
  photo5: img("photo-5", "jpg", 800, 534, [400, 800]),
  photo6: img("photo-6", "jpg", 800, 1433, [400, 800]),
  photo7: img("photo-7", "jpg", 800, 1422, [400, 800]),
  photo8: img("photo-8", "jpg", 800, 940, [400, 800]),
  photo9: img("photo-9", "jpg", 800, 929, [400, 800]),
  photo10: img("photo-10", "jpg", 800, 1000, [400, 800]),
  photo11: img("photo-11", "jpg", 800, 989, [400, 800]),
  photo12: img("photo-12", "jpg", 800, 845, [400, 800]),
  glamLogo: img("glam-logo", "png", 256, 231, [128, 256]),
  celinaLogo: img("celina-logo", "png", 320, 320, [160, 320]),
  celinaWefts: img("celina-wefts", "jpg", 900, 1350, [600, 900]),
  celinaResult: img("celina-result", "jpg", 900, 1350, [600, 900]),
  hiddenRow: img("hidden-row", "jpg", 800, 1200, [400, 800]),
} as const satisfies Record<string, MediaImage>;
